/** Labels voor plan-features zoals ze in de database staan (all_features, products_limit_100, 45_savings, ...). */
export const planFeatureLabel = (key, t) => {
  if (!key) return '';

  const limit = /^products_limit_(\d+)$/.exec(key);
  if (limit) return t('pricing.features.products_limit', { count: Number(limit[1]) });

  const savings = /^(\d+)_savings$/.exec(key);
  if (savings) return t('pricing.features.savings', { amount: `${savings[1]}%` });

  if (key === 'products_unlimited') return t('pricing.features.products_unlimited_all');

  return t(`pricing.features.${key}`, { defaultValue: key.replace(/_/g, ' ') });
};

export default planFeatureLabel;
